import { render, staticRenderFns } from "./EditPolicies.vue?vue&type=template&id=b437af34&scoped=true&"
import script from "./EditPolicies.vue?vue&type=script&lang=js&"
export * from "./EditPolicies.vue?vue&type=script&lang=js&"
import style0 from "./EditPolicies.vue?vue&type=style&index=0&id=b437af34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b437af34",
  null
  
)

export default component.exports